import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh, faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import SvgIcon from '../../utils/Icon';
import { ReactComponent as Informacion } from '../../assets/icons/info.svg';
import CardCitasControl from '../AdminComponent/CardCitasControl';
import Modal from 'react-modal';
import { useState } from 'react';
import Cargando from '../../utils/Cargando';
Modal.setAppElement('#root'); // Para accesibilidad del modal

const CitasControl = ({ cargando, isPatient = true, error, allAppointments, handleVideoCall, handleCancel,
    cancelReason, setCancelReason, updateAllAppointments, onConfirmCancelWithReason, highlightTitle = false }) => {

    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [showReasonModal, setShowReasonModal] = useState(false); // Nuevo estado para el modal de motivo

    const confirmCancel = () => {
        setShowConfirmationModal(false);
        setShowReasonModal(true); // Mostrar modal para ingresar el motivo
    };

    const onHandleClickCancelarCita = (appointmentId, firmoConsentimiento) => {
        handleCancel(appointmentId, firmoConsentimiento);
        setShowConfirmationModal(true);
    }

    const onHandleConfirmarCancelarCita = async () => {
        const res = await onConfirmCancelWithReason();
        if (res) {
            setShowReasonModal(false);
        }
    }


    return (
        <div className="rounded-[1.75rem] md:rounded-[2rem] overflow-hidden shadow-[0_8px_30px_-8px_rgba(31,148,194,0.15),0_4px_16px_-6px_rgba(0,0,0,0.08)]">
            <style>{`
                @keyframes highlight-mis-citas {
                    0%, 100% { box-shadow: 0 0 0 0 rgba(31, 148, 194, 0.5); transform: scale(1); }
                    50% { box-shadow: 0 0 24px 10px rgba(255, 255, 255, 0.35); transform: scale(1.01); }
                }
                .mis-citas-highlight {
                    animation: highlight-mis-citas 1.2s ease-in-out 3;
                }
            `}</style>
            {error && (
                <div className="mx-4 mt-4 md:mx-6 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-2xl text-sm">
                    <span className="block sm:inline">{error}</span>
                </div>
            )}

            <h2 className={`flex justify-between items-center bg-gradient-to-r from-[#1f94c2ff] to-[#1a7fa8] px-5 md:px-8 py-2 text-white font-medium text-sm md:text-base rounded-t-[1.75rem] md:rounded-t-[2rem] transition-all ${highlightTitle ? 'mis-citas-highlight' : ''}`}>
                <span className="flex items-center">
                    <SvgIcon Icon={Informacion} className="w-5 h-5 md:w-6 md:h-6 mr-2 md:mr-3 shrink-0" /> Mis citas
                </span>
                <button
                    type="button"
                    onClick={updateAllAppointments}
                    className="p-2 rounded-xl bg-white/20 hover:bg-white/30 transition-colors"
                    aria-label="Actualizar citas"
                >
                    <FontAwesomeIcon icon={faRefresh} className="w-5 h-5 md:w-6 md:h-6 text-white" />
                </button>
            </h2>
            <div className="pt-6 md:pt-8 pb-4 md:pb-5 px-4 md:px-6 overflow-x-auto overflow-y-visible">
                {cargando ? (
                    <Cargando message="Cargando citas..." altura="min" />
                ) : (
                    <>
                        <div className="flex flex-col sm:flex-row sm:flex-wrap gap-4 sm:gap-5 md:gap-6 w-full pb-2 items-stretch">
                            <CardCitasControl
                                isPatient={isPatient}
                                allAppointments={allAppointments}
                                handleVideoCall={handleVideoCall}
                                handleCancel={onHandleClickCancelarCita}
                            />
                        </div>
                        {!allAppointments.length && (
                            <div className="flex flex-col items-center justify-center py-6 md:py-8 px-4 mt-2">
                                <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-slate-100 flex items-center justify-center mb-3 ring-2 ring-slate-100">
                                    <FontAwesomeIcon icon={faCalendarDays} className="w-6 h-6 md:w-8 md:h-8 text-[#1f94c2ff]" />
                                </div>
                                <h3 className="text-base md:text-lg font-semibold text-slate-700 mb-0.5">No hay citas programadas</h3>
                                <p className="text-slate-500 text-xs md:text-sm text-center max-w-xs">Cuando agendes una cita con un profesional aparecerá aquí.</p>
                            </div>
                        )}
                    </>
                )}
            </div>

            {/* Modal de confirmación */}

            <Modal
                isOpen={showConfirmationModal}
                onRequestClose={() => setShowConfirmationModal(false)}
                className="w-[90%] max-w-[360px] mx-auto bg-white p-5 md:p-6 rounded-2xl shadow-xl text-center border border-slate-100 focus:outline-none"
                overlayClassName="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm z-50 p-4"
            >
                <h2 className="text-base md:text-lg text-slate-700 font-semibold mb-5">
                    ¿Estás seguro de que quieres cancelar esta cita?
                </h2>
                <div className="flex justify-center gap-3">
                    <button onClick={() => setShowConfirmationModal(false)} className="flex-1 bg-slate-200 text-slate-700 font-medium px-4 py-2.5 rounded-xl hover:bg-slate-300 transition-colors text-sm md:text-base">
                        No
                    </button>
                    <button onClick={confirmCancel} className="flex-1 bg-red-500 hover:bg-red-600 text-white font-medium px-4 py-2.5 rounded-xl transition-colors text-sm md:text-base">
                        Sí
                    </button>
                </div>
            </Modal>

            <Modal
                isOpen={showReasonModal}
                onRequestClose={() => setShowReasonModal(false)}
                className="w-[90%] max-w-[360px] mx-auto bg-white p-5 md:p-6 rounded-2xl shadow-xl text-center border border-slate-100 focus:outline-none"
                overlayClassName="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm z-50 p-4"
            >
                <h2 className="text-base md:text-lg text-left text-slate-700 font-semibold mb-3">
                    Por favor, ingresa el motivo de la cancelación:
                </h2>
                <textarea
                    placeholder="Motivo de la cancelación"
                    value={cancelReason}
                    onChange={(e) => setCancelReason(e.target.value)}
                    className="border border-slate-200 rounded-xl w-full focus:outline-none focus:ring-2 focus:ring-[#1f94c2ff]/30 focus:border-[#1f94c2ff] mb-4 p-3 text-sm md:text-base min-h-[88px]"
                    rows="3"
                />
                <div className="flex justify-center gap-3">
                    <button onClick={() => setShowReasonModal(false)} className="flex-1 bg-slate-200 text-slate-700 font-medium px-4 py-2.5 rounded-xl hover:bg-slate-300 transition-colors text-sm md:text-base">
                        Cancelar
                    </button>
                    <button onClick={onHandleConfirmarCancelarCita} className="flex-1 bg-[#1f94c2ff] hover:bg-[#1a7fa8] text-white font-medium px-4 py-2.5 rounded-xl transition-colors text-sm md:text-base">
                        Confirmar
                    </button>
                </div>
            </Modal>
        </div>
    )
}
export default CitasControl;